// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"249c3aec","82":"a03b705f","105":"aa65da14","110":"7c0671fa","330":"95fe3879","331":"2a4189ea","450":"6d208fbd","453":"09dbfeaa","674":"909e8757","704":"1f43b9ff"}[chunkId] + ".chunk.js";
};